export const ALL_INDUSTRIES = [
  'SaaS', 'E-commerce', 'FinTech', 'HealthTech', 'EdTech', 'Retail', 'Manufacturing',
  'Services', 'Media', 'Real Estate', 'Logistics', 'Energy', 'Telecom', 'Insurance',
  'Legal', 'Consulting', 'Marketing', 'HR Tech', 'PropTech', 'AgTech', 'CleanTech',
  'BioTech', 'Automotive', 'Aerospace', 'Gaming', 'Entertainment', 'Travel',
  'Hospitality', 'Food & Beverage', 'Fashion'
] as const;

export const ALL_REGIONS = [
  'United States', 'Canada', 'United Kingdom', 'Germany', 'France', 'Australia',
  'Singapore', 'India', 'Japan', 'Brazil', 'Mexico', 'Spain', 'Italy', 'Netherlands',
  'Sweden', 'Norway', 'Denmark', 'Switzerland', 'Ireland', 'New Zealand', 'South Korea',
  'China', 'UAE', 'Israel', 'South Africa', 'Argentina', 'Chile', 'Colombia', 'Poland',
  'Belgium', 'Austria', 'Portugal', 'Finland'
] as const;

export const INDUSTRY_QUICK_SELECTS = [
  { label: 'Tech', values: ['SaaS', 'FinTech', 'HealthTech', 'EdTech', 'HR Tech'] },
  { label: 'Common', values: ['SaaS', 'E-commerce', 'FinTech', 'HealthTech', 'EdTech', 'Retail', 'Manufacturing', 'Services', 'Media'] },
  { label: 'All', values: [...ALL_INDUSTRIES] },
];

export const REGION_QUICK_SELECTS = [
  { label: 'NA', values: ['United States', 'Canada'] },
  { label: 'EU', values: ['United Kingdom', 'Germany', 'France', 'Netherlands', 'Spain', 'Italy', 'Sweden'] },
  { label: 'APAC', values: ['Australia', 'Singapore', 'Japan', 'India', 'South Korea'] },
  { label: 'All', values: [...ALL_REGIONS] },
];

export const COMPANY_SIZES = [
  { value: '1-10', label: '1-10' },
  { value: '11-50', label: '11-50' },
  { value: '51-200', label: '51-200' },
  { value: '201-500', label: '201-500' },
  { value: '501-1000', label: '501-1K' },
  { value: '1001-5000', label: '1K-5K' },
  { value: '5000+', label: '5K+' },
] as const;

export const CUSTOMER_TYPES = [
  { id: 'B2B', label: 'B2B' },
  { id: 'B2C', label: 'B2C' },
  { id: 'Both', label: 'Both' },
] as const;

export const SELLING_MOTIONS = [
  { id: 'sales-led', label: 'Sales' },
  { id: 'plg', label: 'PLG' },
  { id: 'services', label: 'Services' },
] as const;
